import { Center, CenterProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export type BoardBoxProps = CenterProps & PropsWithChildren;

export const BoardBox: React.FC<BoardBoxProps> = ({ children, ...rest }) => {
  // Use very thin borders (1px) for a tight grid appearance
  // Black background shows between cells for the classic Jeopardy look
  // Width is 100% of parent (category column), height is 1/6 of parent (6 rows: 1 category + 5 clues)
  return (
    <Center
      borderColor="black"
      borderStyle="solid"
      borderWidth="1px"
      w="100%"
      h={`${100 / 6}%`}
      flexGrow={1}
      flexShrink={0}
      boxSizing="border-box"
      backgroundColor="jeopardy.blue"
      padding="0.4em"
      px="1em"
      py="0.2em"
      overflow="hidden"
      {...rest}
    >
      {children}
    </Center>
  );
};
